import { Component, Input, OnInit } from '@angular/core';
import { ChecklistItem } from 'app/interfaces/checklistItem';

@Component({
	selector: 'bb-checklist',
	templateUrl: './bb-checklist.component.html',
	styleUrls: ['./bb-checklist.component.scss']
})

export class BbChecklistComponent implements OnInit {
	@Input() items: ChecklistItem[];
	@Input() title: string;

	ngOnInit() { }
}
